var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.image)?_c('img',{staticClass:"tab-image",style:(_vm.imgStyle),attrs:{"data-test":"tab-image-img","src":_vm.image,"alt":_vm.alt}}):_c('font-awesome-icon',{staticClass:"tab-image",style:(_vm.faStyle),attrs:{"data-test":"tab-image-font-awesome-icon","icon":_vm.icon,"fixed-width":_vm.fixedWidth}})
}
var staticRenderFns = []

export { render, staticRenderFns }